/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_DescriptionInputs */

const es_chat_share_modal_description = /** @type {(inputs: Chat_Share_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu chat ahora es público. Cualquier persona con el enlace puede ver esta conversación.`)
};

const en_chat_share_modal_description = /** @type {(inputs: Chat_Share_Modal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your chat is now public. Anyone with the link can view this conversation.`)
};

/**
* | output |
* | --- |
* | "Your chat is now public. Anyone with the link can view this conversation." |
*
* @param {Chat_Share_Modal_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_description = /** @type {((inputs?: Chat_Share_Modal_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_description(inputs)
	return en_chat_share_modal_description(inputs)
});
export { chat_share_modal_description as "chat.share_modal.description" }